import { UseNotifications, useNotifications } from '@elearning-platform/ui';
import { TransProps, useTranslation } from 'react-i18next';

import { userVerificationReminderPopupDisable } from '../api/requests';
import { RouteNameEnum } from '../enums';
import { UseActionsAfterSignIn, UseRedirectTo } from '../interfaces/hooks';
import { LoginResponse } from '../types/api';

import { useRedirectTo } from './useRedirectTo.hook';

export const useActionsAfterSignIn: () => UseActionsAfterSignIn = (): UseActionsAfterSignIn => {
  const { addToast, showPopup, hidePopup }: UseNotifications = useNotifications();
  const { redirect }: UseRedirectTo = useRedirectTo();
  const { t }: TransProps<never> = useTranslation();

  const actionsAfterSignIn: (loginResponse: LoginResponse) => void = (loginResponse: LoginResponse): void => {
    if (loginResponse.passwordExpirationInfo?.forceChange) {
      return;
    }

    if (loginResponse.passwordExpirationInfo?.remindChange) {
      showPopup({
        title: t('competence.app.useActionsAfterSignIn.passwordReminderPopup.title'),
        description: t(
          'competence.app.useActionsAfterSignIn.passwordReminderPopup.description',
          { daysLeft: loginResponse.passwordExpirationInfo?.daysToForceChange }
        ),
        acceptButtonData: {
          label: t('competence.app.useActionsAfterSignIn.passwordReminderPopup.changePassword'),
          onClick: (): void => {
            redirect({ route: RouteNameEnum.ProfileDetails });
            hidePopup();
          },
        },
        cancelButtonData: {
          label: t('competence.app.useActionsAfterSignIn.passwordReminderPopup.remindLater'),
          onClick: (): void => hidePopup(),
        },
      });
    } else if (loginResponse.user.requireVerification && !loginResponse.user.requiredActions.length) {
      showPopup({
        title: t('competence.app.useActionsAfterSignIn.requireVerificationPopup.title'),
        description: t('competence.app.useActionsAfterSignIn.requireVerificationPopup.description'),
        acceptButtonData: {
          label: t('competence.app.useActionsAfterSignIn.requireVerificationPopup.acceptButtonLabel'),
          onClick: (): void => {
            userVerificationReminderPopupDisable().catch((error: Error): void => addToast({ text: error.message }));
            redirect({ route: RouteNameEnum.ProfileDetails });
            hidePopup();
          },
        },
      });
    }
  };

  return {
    actionsAfterSignIn,
  };
};
